/* Smooth scroll for in-page anchor links (e.g. PDP "jump to reviews" #trustpilot).
   Scoped to pure same-page anchors so it never touches programmatic scrolling
   (pagination restore, drawers, etc.). Accounts for the sticky header offset. */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getHeaderOffset() {
    var header = document.querySelector('#shopify-section-header');
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') {
        return header.getBoundingClientRect().height + 16;
      }
    }
    return 16;
  }

  function scrollToTarget(target) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({
      top: Math.max(top, 0),
      behavior: prefersReducedMotion() ? 'auto' : 'smooth'
    });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;

    // Let other handlers win (e.g. account popup #login / #recover toggles).
    if (e.defaultPrevented) return;

    var href = link.getAttribute('href');
    // Only pure in-page anchors ("#id"), not "/page#id" or "#".
    if (!href || href.charAt(0) !== '#' || href.length < 2) return;

    var id = href.slice(1);
    var target = document.getElementById(id);
    if (!target && typeof CSS !== 'undefined' && CSS.escape) {
      target = document.querySelector('[name="' + CSS.escape(id) + '"]');
    }
    if (!target) return; // No matching element: leave default behavior intact.

    e.preventDefault();
    scrollToTarget(target);

    if (history.pushState) {
      history.pushState(null, '', '#' + id);
    }
  }, false);
})();